import { Property } from '../../../services/dtos/property';
import { BreadcrumbItem } from '../../components/breadcrumb/Breadcrumb';
import { buildSerpURLObject, buildListingURLObject } from '../links';

export interface BuildBreadcrumb {
  province?: string,
  locality?: string,
  area?: string,
  property?: Property,
}

export function buildBreadcrumb(
  {
    province, locality, area, property,
  }: BuildBreadcrumb,
) {
  const serpUrl = buildSerpURLObject();

  const breadcrumbItems: BreadcrumbItem[] = [
    {
      label: 'Vendita case',
      urlObject: serpUrl,
    },
  ];

  if (province) {
    const provinceSerpUrl = buildSerpURLObject({ province });
    breadcrumbItems.push({
      label: `Provincia di ${province}`,
      urlObject: provinceSerpUrl,
    });
  }

  if (locality) {
    const localitySerpUrl = buildSerpURLObject({ locality });
    breadcrumbItems.push({
      label: locality,
      urlObject: localitySerpUrl,
    });
  }

  if (area) {
    const areaSerpUrl = buildSerpURLObject({ locality, area });
    breadcrumbItems.push({
      label: area,
      urlObject: areaSerpUrl,
    });
  }

  if (property) {
    const listingUrl = buildListingURLObject(property);

    breadcrumbItems.push({
      label: property.title,
      urlObject: listingUrl, // Keep it for JSON-LD data
    });
  }

  return breadcrumbItems;
}

export default buildBreadcrumb;
